import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from '../../../vass-core/components/modal/confirmation.service';
import { AuthService } from '../../services/auth/auth.service';
import { CommonService } from '../../services/common/common.service';
import { UserDataService } from '../../services/user-data/user-data.service';
import {
  APPRAISAL_NAME,
  APPRAISAL_URL,
  DOCUMENTATION_URL,
  ECONOMIC_STUDY_URL,
  LAYOUT_URL,
  LOGIN_NAME,
  LOGIN_SECOND_HOLDER,
  MIN_STATUS,
  PRE_SIMULATOR_URL,
  RESULT_URL,
  SIGN_IN_URL,
  SUMMARY_SECOND_HOLDER_URL,
  WALL_IN_URL,
} from '../../utils/constants';
import { ModalGenericComponent } from '../modal-generic/modal-generic.component';

@Component({
  selector: 'app-header-pibank',
  templateUrl: './header-pibank.component.html',
  styleUrls: ['./header-pibank.component.scss'],
  standalone: false,
})
export class HeaderPibankComponent implements OnInit, OnChanges {
  @Input() isAuthenticated: boolean;

  public isRejected = false;

  public LAYOUT_URL = LAYOUT_URL;
  public APPRAISAL_NAME = APPRAISAL_NAME;
  public ECONOMIC_STUDY_URL = ECONOMIC_STUDY_URL;
  public RESULT_URL = RESULT_URL;
  public DOCUMENTATION_URL = DOCUMENTATION_URL;
  public APPRAISAL_URL = APPRAISAL_URL;
  public SIGN_IN_URL = SIGN_IN_URL;
  public WALL_IN_URL = WALL_IN_URL;
  public SUMMARY_SECOND_HOLDER_URL = SUMMARY_SECOND_HOLDER_URL;
  public login = LOGIN_NAME;

  public loginForm: UntypedFormGroup;
  public email: string = '';
  public isMenuOpen: boolean;
  public showMenu: boolean = false;
  public canNavigateToEconomicStudy: boolean = true;
  public status = 0;
  public emailLoaded: boolean = false;
  public isSecondHolder: boolean = false;
  public minStatus = MIN_STATUS;

  public hiddenBtn = false;

  constructor(
    private router: Router,
    private _commonService: CommonService,
    private _userDataService: UserDataService,
    private authService: AuthService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
  ) {
    this.router.events.subscribe((event: any) => {
      if (event.url !== PRE_SIMULATOR_URL && this.authService.isAuthenticated()) {
        this.showMenu = true;
      } else {
        this.showMenu = false;
      }
      if (!!sessionStorage.getItem('second-holder')) {
        this.email = sessionStorage.getItem('second-holder');
        this.isSecondHolder = true;
      } else {
        this.isSecondHolder = false;
      }
      this.hiddenBtn = event.url === `/${LOGIN_SECOND_HOLDER}`;
    });
  }

  ngOnInit() {
    this.getIsAuth();
    this.getRemoteStatus();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getIsAuth();
  }

  private getIsAuth() {
    if (this.isAuthenticated) {
      this.getUserData();
    }
  }

  private getRemoteStatus() {
    this.authService.getStatus().subscribe((response) => {
      /*this.isLogged = parseInt(response, 10) > 0 ? true : false;
            if (this.isLogged) {
                this.getUserData();
            }*/
      this.status = parseInt(response, 10);
      this.canNavigateToEconomicStudy = this.status < 2;
    });

    this.authService.getRejectedMortgage().subscribe((data) => (this.isRejected = data));
  }

  private getUserData() {
    this._userDataService.subscribeChanges().subscribe((change) => {
      if (change) {
        this.emailLoaded = true;
        if (!!sessionStorage.getItem('second-holder')) {
          this.email = sessionStorage.getItem('second-holder');
        } else {
          this.email = this._userDataService.getUserData().level2Data.holders[0].email;
        }
      }
    });
  }

  confirmLogout() {
    const data = {
      message: this.translate.instant(`modal_logut_msg`),
      txtButton: this.translate.instant('modal_logut_btn'),
      txtButtonCancel: this.translate.instant('btn_cancel'),
    };
    const options: Object = {
      header: this.translate.instant(`modal_logut_title`),
      showHeader: true,
      closeOnEscape: true,
      closable: true,
      styleClass: 'modal-class text-center',
      cancelButton: false,
      acceptButton: false,
    };

    this.confirmationService.confirm(<any>{
      component: ModalGenericComponent,
      options: options,
      data: data,
      accept: (data) => {
        this.logout();
      },
      reject: () => {},
    });
  }

  public logout() {
    this.authService.revokeToken().subscribe(
      (resp) => {
        this.authService.logout();
      },
      (err) => {},
    );
  }

  public recoverRequest(needRegister = false) {
    this._commonService.openModalLogin(needRegister, true);
  }

  public toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  public hideMenu() {
    if (this.isMenuOpen) {
      this.isMenuOpen = false;
    }
  }
}
